// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const disconnectAppPathParamsSchema = z.object({
  app_id: z.number().int().describe("App id"),
  id: z.number().int().describe("AppUser id"),
});

export const disconnectAppHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description App disconnected
 */
export const disconnectApp200Schema = z.object({});

/**
 * @description Forbidden - User cannot manage this integration
 */
export const disconnectApp403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description AppUser not found
 */
export const disconnectApp404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const disconnectAppMutationResponseSchema = z.lazy(() => disconnectApp200Schema);
